import { supabase } from "../supabase/client";
import { loadStarBalance } from "../economy/starWallet";

export interface CompletionResult { totalStars: number | null; awardedStars: number }

function appendHistory(taskId: string, title: string, stars: number) {
  let history: Array<Record<string, unknown>> = [];
  try { const parsed = JSON.parse(localStorage.getItem("lusky:task-history") || "[]"); history = Array.isArray(parsed) ? parsed : []; } catch { history = []; }
  if (!history.some((item) => item.taskId === taskId || String(item.id || "").startsWith(taskId))) {
    const completedAt = new Date().toISOString();
    history.push({ id: `${taskId}-${completedAt.slice(0, 10)}`, taskId, title, status: "completed", stars, completedAt, date: completedAt.slice(0, 10) });
    localStorage.setItem("lusky:task-history", JSON.stringify(history));
  }
}

export async function completeLearningTask(childId: string | null, taskId: string, title: string, stars = 3): Promise<CompletionResult> {
  appendHistory(taskId, title, stars);
  if (!supabase || !childId || !/^[0-9a-f-]{36}$/i.test(childId)) return { totalStars: null, awardedStars: stars };
  try {
    const { data, error } = await supabase.rpc("claim_task_reward", {
      p_child_id: childId,
      p_task_id: taskId,
      p_completion_key: `${taskId}:first-completion:v2`,
      p_stars: stars,
      p_payload: { source: "react_learning_runner", completed_at: new Date().toISOString() }
    });
    if (error) return { totalStars: null, awardedStars: 0 };
    const row = Array.isArray(data) ? data[0] : data;
    const grossTotal = row && typeof row.total_stars !== "undefined" ? Number(row.total_stars) : 0;
    const totalStars = await loadStarBalance(childId, grossTotal);
    return { totalStars, awardedStars: row && typeof row.stars !== "undefined" ? Number(row.stars) : 0 };
  } catch { return { totalStars: null, awardedStars: 0 }; }
}